import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';

interface DashboardGridProps {
  className?: string;
  children: ReactNode;
}

export function DashboardGrid({ className, children }: DashboardGridProps) {
  return (
    <div className={cn('grid grid-cols-1 gap-4 lg:grid-cols-3', className)}>
      {children}
    </div>
  );
}
